import React from "react";
import compose from "ramda/src/compose";
import pathOr from "ramda/src/pathOr";
import path from "ramda/src/path";
import sortBy from "ramda/src/sortBy";
import last from "ramda/src/last";
import CopyIcon from "@atlaskit/icon/glyph/copy";

import { Button } from "../../UI/Button";
import { useSnackbar } from "../../hooks/useSnackbar";
import { SendInvitationModal } from "../SendInvitationModal";
import { useUserContext } from "../../contexts/UserContext";
import { getDate } from "../../common/date_utils";
import { Invitation } from "../../services/NetworkApi";
import { Grid } from "../../UI/Grid";
import { copyToClipboard } from "../../helpers/copyToClipboard";
import { generateQuickjoinLink } from "../../helpers/generateQuickjoinLink";

const sortByCreatedAt = sortBy(compose((date: any) => date?.valueOf(), getDate, path(["createdAt"])));

const getLastInvitation = compose(last, sortByCreatedAt, pathOr([], ["invitations"]));

export const NoRegisterUserActions = () => {
  const { user } = useUserContext();
  const { showSuccessSnackbar } = useSnackbar();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleInvitationResend = () => {
    setIsOpen(true);
  };

  const onCloseSendInvitationModal = () => {
    setIsOpen(false);
  };

  const onSuccessInvitationModal = () => {
    showSuccessSnackbar("Invitation sent!");
    setIsOpen(false);
  };

  const invitation = getLastInvitation(user) as Invitation;

  const handleCopy = async () => {
    copyToClipboard(generateQuickjoinLink(invitation.id));
    showSuccessSnackbar("Successfully copied to clipboard");
  };

  return (
    <>
      {user && invitation?.id && (
        <Grid container spacing={1} wrap="nowrap">
          <Grid item>
            <Button appearance="primary" onClick={handleInvitationResend}>
              Resend Invitation
            </Button>
            <SendInvitationModal
              open={isOpen}
              invitationId={invitation.id}
              onClose={onCloseSendInvitationModal}
              onSuccess={onSuccessInvitationModal}
              name={`${user?.firstName} ${user?.lastName}`}
            />
          </Grid>
          <Grid item>
            <Button onClick={handleCopy} iconBefore={<CopyIcon label="copy link" />}>
              Copy Link
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
};
